var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-campaign-template-tab',{attrs:{"title":"Boost Sales"}},[_c('p',[_vm._v("This campaign will help you to boost your sales!")])])}
var staticRenderFns = []

export { render, staticRenderFns }